"use client";

import { useMemo } from "react";
import PropTypes from "prop-types";
import { formatPhoneView } from "src/utils/ui";
import phoneMasking, { PHONE_MARKER } from "src/utils/ui/newPhoneMasking";
import Title from "components/listing-detail/title";
import MoreContent from "components/listing-detail/more-content";
import JetHatReveal from "@/src/components/jethat-reveal";
import styles from "./styles.module.css";

const Description = ({ data, jethat, listingId }) => {
  const phoneNumber = useMemo(() => {
    if (!jethat) return "";
    return jethat.startsWith("+9") ? jethat.split("+9")[1] : jethat;
  }, [jethat]);
  const formattedJetHat = useMemo(() => formatPhoneView(phoneNumber), [phoneNumber]);

  const maskedDesc = useMemo(() => {
    if (jethat && (jethat.indexOf("850") >= 0 || jethat.indexOf("312") >= 0)) {
      return phoneMasking(data);
    }
    return data;
  }, [data, jethat]);

  const descParts = useMemo(() => maskedDesc.split(PHONE_MARKER), [maskedDesc]);

  const cleanHeadings = (html) =>
    html.replace(/<(h[1-3])[^>]*>([\s\S]*?)<\/\1>/g, (match, tag, content) => {
      let fontSize, marginBlockStart, marginBlockEnd;
      switch (tag) {
        case "h1":
          fontSize = "2em";
          marginBlockStart = "0.67em";
          marginBlockEnd = "0.67em";
          break;
        case "h2":
          fontSize = "1.5em";
          marginBlockStart = "0.83em";
          marginBlockEnd = "0.83em";
          break;
        case "p":
          fontSize = "1.17em";
          marginBlockStart = "1em";
          marginBlockEnd = "1em";
          break;
        default:
          fontSize = "1em";
          marginBlockStart = "0";
          marginBlockEnd = "0";
      }
      return `<span style="display:block; margin-block-start: ${marginBlockStart};margin-block-end: ${marginBlockEnd}; font-size: ${fontSize}; font-weight: bold;">${content}</span>`;
    });

  return (
    <div className={styles.wrapper}>
      <Title>İlan Açıklaması</Title>
      <MoreContent defaultHeight={251}>
        <div className={styles.inner}>
          {descParts.map((part, idx) => (
            <span key={idx}>
              <span dangerouslySetInnerHTML={{ __html: cleanHeadings(part) }} />
              {idx < descParts.length - 1 && <JetHatReveal jethat={formattedJetHat} listingId={listingId} />}
            </span>
          ))}
        </div>
      </MoreContent>
    </div>
  );
};

Description.propTypes = {
  data: PropTypes.string,
  jethat: PropTypes.string,
  listingId: PropTypes.number,
};

export default Description;
